export const queryParamKeys = {
  goalId: 'goalId',
  goalName: 'goalName',
  tab: 'tab',
};
